import { authGet } from "@api";

import { GetPolicyResponse } from "@pages/policy/types";

export const fetchPolicy = (
  deploymentId: string,
  policySlug: string
): Promise<GetPolicyResponse> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policySlug}`;
  return authGet<GetPolicyResponse>(path);
};
